import client from './client'
import type {
  Deployment,
  DeploymentListResponse,
  DeploymentFilters,
  PromoteRequest,
  RollbackRequest,
  DeployResponse,
  RollbackResponse,
  DeployLockStatus,
  InfraDeployRequest,
  InfraDeployResponse,
} from '@/types/deployment.types'

export const deploymentsApi = {
  async list(filters?: DeploymentFilters): Promise<DeploymentListResponse> {
    const res = await client.get<DeploymentListResponse>('/api/deployments', { params: filters })
    return res.data
  },

  async get(id: string): Promise<Deployment> {
    const res = await client.get<Deployment>(`/api/deployments/${id}`)
    return res.data
  },

  async getLockStatus(): Promise<DeployLockStatus> {
    const res = await client.get<DeployLockStatus>('/api/deployments/lock')
    return res.data
  },

  async promote(payload: PromoteRequest): Promise<DeployResponse> {
    const res = await client.post<DeployResponse>('/api/deployments/promote', payload)
    return res.data
  },

  async rollback(payload: RollbackRequest): Promise<RollbackResponse> {
    const res = await client.post<RollbackResponse>('/api/deployments/rollback', payload)
    return res.data
  },
}

export const infraDeployApi = {
  async getDependencies(id: string) {
    const res = await client.get(`/api/infra/${id}/dependencies`)
    return res.data
  },

  async deploy(id: string, payload: InfraDeployRequest): Promise<InfraDeployResponse> {
    const res = await client.post<InfraDeployResponse>(`/api/infra/${id}/deploy`, payload)
    return res.data
  },
}
